'use client';

import { useEffect } from 'react';
import { AlertCircle } from 'lucide-react'; // Mock icon

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log to reporting service
    console.error('Route error caught', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-bg-s2 border border-border rounded-lg mt-8">
      <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
      <h2 className="text-2xl font-bold mb-2">Terjadi Kesalahan</h2>
      <p className="text-text-secondary mb-6 max-w-md">
        Sistem kami mengalami kendala saat memuat halaman ini. Silakan coba lagi atau hubungi dukungan teknis.
      </p>
      <button 
        onClick={() => reset()}
        className="px-6 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-md font-medium transition-colors"
      >
        Coba Lagi
      </button>
    </div>
  );
}
